module.exports = __webpack_public_path__ + "fonts/rubik-light-webfont.8c320a53.8c320a53.woff2";